// extracted by mini-css-extract-plugin
export default {"root":"NotificationText_root__3kmH9"};